import React from 'react'

function Error() {
  return (
    <div>Error Page</div>
  )
}

export default Error